import * as Highcharts from 'highcharts';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import {Card, CardContent} from '@mui/material';

interface IBusinessProfileProps {
    final: any[],
}

const transform = [
    {
        name: 'Business',
        value: 'BIZ_SUCCESS_FAC_COACH',
    },
    {
        name: 'Increased self-confidence in the business idea',
        value: 'BIZ_SUCCESS_FAC_CONF',
    },
    {
        name: 'Having found a financier',
        value: 'BIZ_SUCCESS_FAC_FINANCIER',
    },
    {
        name: 'Other',
        value: 'other',
    },
]

const SuccessFactor = ({final}: IBusinessProfileProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        let data = transform.map((el) => ({
            name: el.name,
            y: 0,
        }));

        final.forEach((submission: any) => {
            transform.forEach((el, index) => {
                if (submission.biz_success_fac && submission.biz_success_fac.indexOf(el.value) > -1) {
                    data[index].y = data[index].y + 1
                }
            })
        })

        const dashboardOptions: any = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                height: 300
            },
            title: {
                text: '',
                align: 'left'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
                colorByPoint: true,
                data
            }]
        };

        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className="chart-container">
            <CardContent>
                {
                    options && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={options}
                            ref={chartComponentRef}
                        />
                    )
                }
            </CardContent>
        </Card>
    );
};

export default SuccessFactor;
